import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

const USER_ENDPOINT = {
  CREATE_USER: "/auth/create-user",
  GET_ALL_USERS: "/auth/users",
  UPDATE_USER: "/auth/update-user",
  DELETE_USER: "/auth/delete-user",
  LOGIN_AS_USER: "/auth/login-as",
}

export type USER = {
  _id: string
  email: string
  role: string | {
    _id: string
    name: string
    permissions: string[]
    createdBy?: string
    isActive: boolean
    isEmployee: boolean
    createdAt: string
    updatedAt: string
  }
  firstName: string
  lastName: string
  phoneNumber?: string
  createdBy: string
  createdAt: string
  updatedAt: string
  status: string
  employeeID?: string | {
    department:string;
    designation:string;
    employeeID:string
  }
  password: string
  department?: string
  designation?: string
  joiningDate?: string
  // Multi-branch: home campus + additional campuses this user may access.
  branch?: string | { _id: string; name?: string }
  accessibleBranches?: (string | { _id: string; name?: string })[]
}

export type USER_PAYLOAD = {
  email: string
  password: string
  role: string
  firstName: string
  lastName: string
  phoneNumber?: string
  status: string
  department?: string
  designation?: string
  joiningDate?: string
  branch?: string
  accessibleBranches?: string[]
}

const createUser = async (data: USER_PAYLOAD): Promise<USER> => {
  const response = await apiClient({
    url: USER_ENDPOINT.CREATE_USER,
    method: "POST",
    data,
  })
  return response.data
}

const getAllUsers = async ({
  page = 1,
  limit = 10,
  role,
  searchText: search,
  sortBy,
  sortOrder,
  status,
}: {
  page?: number
  limit?: number
  role?: string
  searchText?: string
  sortBy?: string
  sortOrder?: string
  status?: string
}): Promise<{ pagination: any; data: USER[] }> => {
  const response = await apiClient({
    url: appendQueryParams(USER_ENDPOINT.GET_ALL_USERS, {
      page,
      limit,
      role,
      searchText: search,
      sortBy,
      sortOrder,
      status,
    }),
    method: "GET",
  })
  return response.data
}

const updateUser = async (
  id: string,
  data: Partial<USER_PAYLOAD>
): Promise<USER> => {
  const response = await apiClient({
    url: `${USER_ENDPOINT.UPDATE_USER}/${id}`,
    method: "PUT",
    data,
  })
  return response.data
}

const deleteUser = async (id: string) => {
  const response = await apiClient({
    url: `${USER_ENDPOINT.DELETE_USER}/${id}`,
    method: "DELETE",
  })
  return response.data
}

const loginAsUser = async (id: string): Promise<{ token: string; user: USER }> => {
  const response = await apiClient({
    url: `${USER_ENDPOINT.LOGIN_AS_USER}/${id}`,
    method: "POST",
  })
  return response.data
}

export { createUser, deleteUser, getAllUsers, loginAsUser, updateUser }
